import { render, staticRenderFns } from "./ServicePromotion.vue?vue&type=template&id=598de30c&scoped=true"
import script from "./ServicePromotion.vue?vue&type=script&lang=js"
export * from "./ServicePromotion.vue?vue&type=script&lang=js"
import style0 from "./ServicePromotion.vue?vue&type=style&index=0&id=598de30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598de30c",
  null
  
)

export default component.exports